import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface FeedbackRequestSkeletonProps {
  className?: string;
}

const FeedbackRequestSkeleton = ({
  className,
}: FeedbackRequestSkeletonProps) => {
  return (
    <div className={classNames(styles.sectionContainer, "pt-3", className)}>
      <div className="flex flex-col gap-5">
        <div className={styles.headerSkeleton}>
          <SkeletonLoader className={styles.titleSkeleton} />
          <SkeletonLoader className={styles.descriptionSkeleton} />
        </div>

        <div className={styles.commentsSectionSkeleton}>
          <SkeletonLoader className={styles.commentTitleSkeleton} />
          <SkeletonLoader className={styles.commentTextSkeleton} />
          <SkeletonLoader className={styles.commentTextSkeleton} />
          <SkeletonLoader className={styles.commentTextSkeleton} />
        </div>

        <div className={styles.inspirationFilesSkeleton}>
          <SkeletonLoader className={styles.inspirationTitleSkeleton} />

          <div
            className={classNames(
              styles.inspirationFilesList,
              "grid md:grid-cols-2 grid-cols-1 lg:gap-6 md:gap-5 gap-4 mt-3 mb-2",
            )}
          >
            {Array.from({ length: 2 }).map((_, index) => (
              <div key={index} className={styles.inspirationFileItemSkeleton}>
                <div className="flex flex-col">
                  <div className="flex gap-4">
                    <SkeletonLoader className={styles.imgSkeleton} />

                    <div className="flex flex-col gap-2">
                      <SkeletonLoader className={styles.labelTitleSkeleton} />
                      <SkeletonLoader className={styles.labelTextSkeleton} />
                    </div>
                  </div>

                  <div
                    className={classNames(
                      styles.additionalNotesSkeleton,
                      "xs:ml-4",
                    )}
                  >
                    <SkeletonLoader className={styles.notesTitleSkeleton} />
                    <SkeletonLoader className={styles.notesTextSkeleton} />
                    <SkeletonLoader className={styles.notesTextSkeleton} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackRequestSkeleton;
